/* NRNL public-preview commerce lock — 29 Sep 2026 */
(() => {
  const blockedPath = (value) => {
    if (!value) return false;
    try {
      const url = new URL(value, window.location.origin);
      return /^\/cart(?:\/add)?(?:\.js)?\/?$/.test(url.pathname) ||
             /^\/checkout(?:s)?(?:\/|$)/.test(url.pathname);
    } catch (_) {
      return false;
    }
  };

  const isPurchaseControl = (node) => {
    if (!(node instanceof Element)) return false;
    return Boolean(node.closest(
      'button[name="add"],input[name="add"],button[name="checkout"],input[name="checkout"],' +
      '.shopify-payment-button,.quick-add,.quick-add__button,[data-quick-add],' +
      '.cart__checkout-button,.additional-checkout-buttons,additional-checkout-buttons'
    ));
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const link = target.closest('a[href]');
    if ((link && blockedPath(link.href)) || isPurchaseControl(target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (blockedPath(form.action) || form.querySelector('[name="add"],[name="checkout"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  if (window.location.pathname === '/cart') {
    window.location.replace('/collections/all');
  }
})();